/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { get, map } from "lodash";

import {
  Pagination,
  Stack,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/Table";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import { PageSize, countPage } from "../../../config/const"

import { getReportRoutes } from "../../../store/reports/thunk/routes/getAll";

const ReportRoutes = () => {
  const [__] = useTranslation("routes");
  const dispatch = useDispatch();

  const [filter, setFilter] = useState({});
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })

  const routes = useSelector(state => state.reports.routes);

  const getData = ({ page }) => {
    dispatch(getReportRoutes({ page, PageSize, ClientId: 0, ...filter }))
  }

  const reload = () => {
    getData({ page: 1, filter })
  }

  useEffect(() => {
    if (filter.from && filter.till) {
      getData({ page: 1, filter })
    } else {
      getData({page: 1, filter:""})
    }
  }, [dispatch, JSON.stringify(filter)])

  const headTable = [
    {
      key: "idRoute",
      label: __(`table.cols.idRoute`),
      align: "left",
    },
    {
      key: "routeName",
      label: __(`table.cols.routeName`),
      align: "left"
    },
    {
      key: "driverName",
      label: __(`table.cols.driverName`),
      align: "left",
    },
    {
      key: "create",
      label: __(`table.cols.creationDate`),
      align: "center"
    },
    {
      key: "start",
      label: __(`table.cols.dateStart`),
      align: "center"
    },
    {
      key: "end",
      label: __(`table.cols.dateEnd`),
      align: "center"
    },
    {
      key: "ordersQuantity",
      label: __(`table.cols.ordersQuantity`),
      align: "center"
    },
  ]

  const dataTable = map(get(routes, "data.innerData", []), (row, i) => ({
    ...row,
    create: get(row, "creationDate", null) && moment(get(row, "creationDate")).format("L"),
    start: get(row, "dateStart", null) && moment(get(row, "dateStart")).format("L"),
    end: get(row, "dateEnd", null) && moment(get(row, "dateEnd")).format("L"),
    total: `$${get(row, "totalCost")}`,
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(routes, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(routes, "isLoading", false)}
      />
      {get(routes, "isSuccess", true) &&
        <Stack sx={{ mt: 2 }} alignItems="flex-end">
          <Pagination
            count={countPage(get(routes, "totalRecords", 1))}
            page={get(routes, "pageNumber", 1)}
            onChange={onChangePagination}
            color="secondary"
            sx={{ "& li > button": { borderRadius: 1 } }}
          />
        </Stack>
      }
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
    </Layout >
  )
}

export default ReportRoutes;


